import React from 'react';

const Sidebar = ({ activeTab, setActiveTab, isMobileMenuOpen, setIsMobileMenuOpen }) => {
  const handleNavClick = (tab) => {
    setActiveTab(tab);
    // Close mobile menu when navigation item is clicked
    if (setIsMobileMenuOpen) {
      setIsMobileMenuOpen(false);
    }
  };

  return (
    <>
      {/* Mobile overlay */}
      <div 
        className={`mobile-overlay ${isMobileMenuOpen ? 'active' : ''}`}
        onClick={() => setIsMobileMenuOpen && setIsMobileMenuOpen(false)}
      ></div>
      
      <aside className={`sidebar-dash ${isMobileMenuOpen ? 'active' : ''}`}>
        <nav>
          <ul className="nav-list-dash">
            <li>
              <button
                onClick={() => handleNavClick('dashboard')}
                className={`nav-btn ${activeTab === 'dashboard' ? 'active' : ''}`}
              >
                <svg className="nav-icon icon" viewBox="0 0 24 24">
                  <rect x="3" y="3" width="7" height="7"/>
                  <rect x="14" y="3" width="7" height="7"/>
                  <rect x="14" y="14" width="7" height="7"/>
                  <rect x="3" y="14" width="7" height="7"/>
                </svg>
                لوحة التحكم
              </button>
            </li>
            <li>
              <button
                onClick={() => handleNavClick('articles')}
                className={`nav-btn ${activeTab === 'articles' ? 'active' : ''}`}
              >
                <svg className="nav-icon icon" viewBox="0 0 24 24">
                  <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
                  <polyline points="14,2 14,8 20,8"/>
                  <line x1="16" y1="13" x2="8" y2="13"/>
                  <line x1="16" y1="17" x2="8" y2="17"/>
                  <polyline points="10,9 9,9 8,9"/>
                </svg>
                الأخبار
              </button>
            </li>
            <li>
              <button
                onClick={() => handleNavClick('add-news')}
                className={`nav-btn ${activeTab === 'add-news' ? 'active' : ''}`}
              >
                <svg className="nav-icon icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <circle cx="12" cy="12" r="10"/>
                  <line x1="12" y1="8" x2="12" y2="16"/>
                  <line x1="8" y1="12" x2="16" y2="12"/>
                </svg>
                إضافة خبر
              </button>
            </li>
            <li>
              <button
                onClick={() => handleNavClick('categories')}
                className={`nav-btn ${activeTab === 'categories' ? 'active' : ''}`}
              >
                <svg className="nav-icon icon" viewBox="0 0 24 24">
                  <path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"/>
                </svg>
                الأقسام
              </button>
            </li>
            <li>
              <button
                onClick={() => handleNavClick('review')}
                className={`nav-btn ${activeTab === 'review' ? 'active' : ''}`}
              >
                <svg className="nav-icon icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M9 11l3 3l8-8"/>
                  <path d="M21 12c0 4.97-4.03 9-9 9s-9-4.03-9-9s4.03-9 9-9c1.51 0 2.93 0.37 4.18 1.02"/>
                  <path d="M16 3h5v5"/>
                  <path d="M21 3l-7 7"/>
                </svg>
                مراجعة
              </button>
            </li>
            <li>
              <button
                onClick={() => handleNavClick('settings')}
                className={`nav-btn ${activeTab === 'settings' ? 'active' : ''}`}
              >
                <svg className="nav-icon icon" viewBox="0 0 24 24">
                  <circle cx="12" cy="12" r="3"/>
                  <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1 1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z"/>
                </svg>
                الإعدادات
              </button>
            </li>
          </ul>
        </nav>
      </aside>
    </>
  );
};

export default Sidebar;